// Formats CV dates consistently across the site and the PDF.
// New entries store months as "YYYY-MM" (from the <input type="month"> picker);
// older free-text values (e.g. "Septiembre 2021") are shown as-is.

export function formatMonth(value, language) {
  if (!value) return "";
  if (/^\d{4}-\d{2}$/.test(value)) {
    const d = new Date(`${value}-01T00:00:00`);
    return d.toLocaleDateString(language === "es" ? "es-ES" : "en-US", {
      month: "short",
      year: "numeric",
    });
  }
  return value; // backward-compatible: render legacy free text unchanged
}

// `current` true => the entry is ongoing; end is shown as a localized word.
export function formatDateRange(start, end, current, language) {
  const s = formatMonth(start, language);
  const e = current
    ? language === "es"
      ? "Actualidad"
      : "Present"
    : formatMonth(end, language);
  if (!s && !e) return "";
  if (!e) return s;
  return `${s} – ${e}`;
}
